export default "__VITE_ASSET__DZgvcJM$__"